import { useState, type FormEvent } from "react";

export interface PassExtensionPreviewItem {
  pass_id: string;
  student_id: string;
  student_name: string;
  pass_type: "count" | "unlimited";
  expiry_date: string;
  new_expiry_date: string;
}

export function PassExtensionModal({ scope, items, language, onCancel, onConfirm }: {
  scope: "individual" | "bulk";
  items: PassExtensionPreviewItem[];
  language: "zh" | "en";
  onCancel: () => void;
  onConfirm: (pin: string, requestId: string) => Promise<boolean>;
}) {
  const [pin, setPin] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [requestId] = useState(() => crypto.randomUUID());
  const item = items[0];
  const zh = language === "zh";

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true); setError("");
    try {
      if (!await onConfirm(pin, requestId)) setError(zh ? "未能完成延長，請檢查 PIN 後再試。" : "Could not extend passes. Check the PIN and try again.");
    } finally { setSubmitting(false); }
  }

  return <div className="modal-backdrop" role="presentation">
    <section className="confirmation-modal" role="dialog" aria-modal="true" aria-labelledby="pass-extension-title">
      <h2 id="pass-extension-title">{scope === "bulk"
        ? (zh ? "所有有效課卡延長 1 星期" : "Extend all active passes by 1 week")
        : (zh ? "延長 1 星期" : "Extend 1 week")}</h2>
      {scope === "bulk" ? <>
        <p><strong>{items.length}</strong> {zh ? "張有效課卡將會延長。" : "active passes will be extended."}</p>
        <p>{zh ? "每張課卡的最後可用日會延後 7 日。" : "Each last usable date will be moved forward by 7 days."}</p>
      </> : item ? <dl className="confirmation-summary">
        <div><dt>{zh ? "學生" : "Student"}</dt><dd>{item.student_name}</dd></div>
        <div><dt>{zh ? "課卡" : "Pass"}</dt><dd>{item.pass_type === "unlimited" ? (zh ? "無限卡" : "Unlimited") : (zh ? "次數卡" : "Count pass")}</dd></div>
        <div><dt>{zh ? "目前最後可用日" : "Current last usable date"}</dt><dd>{item.expiry_date}</dd></div>
        <div><dt>{zh ? "新最後可用日（+7 日）" : "New last usable date (+7 days)"}</dt><dd>{item.new_expiry_date}</dd></div>
      </dl> : null}
      <form onSubmit={submit}>
        <label><span>{zh ? "確認 PIN" : "Confirmation PIN"}</span>
          <input name="pin" type="password" inputMode="numeric" pattern="[0-9]{4}" minLength={4} maxLength={4}
            autoComplete="off" value={pin} onChange={(event) => setPin(event.target.value)} required autoFocus />
        </label>
        {error && <p role="alert" className="form-error">{error}</p>}
        <div className="row-actions">
          <button className="primary-button" disabled={submitting}>{submitting ? (zh ? "處理中…" : "Working…") : (zh ? "確認延長" : "Confirm extension")}</button>
          <button type="button" className="secondary-button" disabled={submitting} onClick={onCancel}>{zh ? "取消" : "Cancel"}</button>
        </div>
      </form>
    </section>
  </div>;
}
